module.exports = __webpack_public_path__ + "static/img/Bachelor_010303.c9f0ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010303.jpg
// module id = 145
// module chunks = 0